import React, { useState, useMemo, useEffect, useCallback } from "react";
import { Input } from "antd";
import { SearchOutlined } from "@ant-design/icons";
import Menubar from "../../../../components/WhrManager/App";
import { http } from "../../../../services/http";
import CreateInventoryTransferRequest from "./create";
import InventoryTransfersModal from "../../../../components/WhrManager/InventoryTransfersModal";
import { useTranslation } from "react-i18next";
import Header from "../../../../components/header";
import moment from "moment";
import { debouncedSet } from "../../../../utils/debounce";
import debounce from "lodash.debounce";

const InventoryTrasferRequest = () => {
  const { t } = useTranslation();
  const [fdata, setFData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [currentPage, setCurrentPage] = useState(0);
  const [isCreateProductModalVisible, setIsCreateProductModalVisible] =
    useState(false);
  const [selectedRowData, setSelectedRowData] = useState(null);
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [docNum, setDocNum] = useState("");
  const [cardName, setCardName] = useState("");
  const [startDate, setStartDate] = useState("");
  const [endDate, setEndDate] = useState(moment().format("YYYY-MM-DD"));
  const [hasMore, setHasMore] = useState(false);
  const [responsiblePersonData, setResponsiblePersonData] = useState([]);

  const fetchData = useCallback(async (StartDate, EndDate, page) => {
    try {
      setLoading(true);
      const { data } = await http.get(
        `api/inventorytransferrequest?status=Заказано&startDate=${StartDate}&endDate=${EndDate}&skip=${page}&pageSize=20`,
      );

      setHasMore(data.length === 20);
      setFData(data);
    } catch (error) {
      console.log(error);
    }
    setLoading(false);
  }, []);

  const fetchResponsibleManagers = async () => {
    try {
      const { data } = await http.get(
        `api/sales/warehouse-employee-info?skip=0`,
      );
      setResponsiblePersonData(data.data);
      console.log("warehouse-employee", data.data);
    } catch (err) {
      console.log(err);
    }
  };

  useEffect(() => {
    fetchData(startDate, endDate, currentPage);
  }, [fetchData, startDate, endDate, currentPage]);

  useEffect(() => {
    fetchResponsibleManagers();
  }, []);

  const handleNextPage = () => {
    setCurrentPage((prevPage) => prevPage + 1);
  };

  const handlePreviousPage = () => {
    setCurrentPage((prevPage) => prevPage - 1);
  };

  const handleStartDate = (e) => {
    debouncedSet(e.target.value, setStartDate);
  };

  const handleEndDate = (e) => {
    debouncedSet(e.target.value, setEndDate);
  };

  const handleRowClick = (record) => {
    setSelectedRowData(record);
    setIsModalVisible(true);
  };

  const handleCreateProductClick = () => {
    setIsCreateProductModalVisible(true);
  };

  const closeCreateProductModal = () => {
    setIsCreateProductModalVisible(false);
    fetchData(startDate, endDate, 0);
  };
  const closeViewModal = () => {
    setIsModalVisible(false);
    fetchData(startDate, endDate, 0);
  };

  const debouncedSearch = useMemo(
    () =>
      debounce((value, dataIndex, confirm) => {
        if (dataIndex === "cardName") {
          if (value) {
            setCardName(value);
          } else {
            setCardName("");
          }
        } else if (dataIndex === "docNum") {
          if (value) {
            setDocNum(value);
          } else {
            setDocNum("");
          }
        }

        confirm();
      }, 3000),
    [fetchData, currentPage],
  );

  let searchInput;

  const getColumnSearchProps = (dataIndex) => {
    return {
      filterDropdown: ({ setSelectedKeys, selectedKeys, confirm }) => (
        <div style={{ padding: 8 }}>
          <Input
            ref={(node) => {
              searchInput = node;
            }}
            placeholder={`${t("search")} ${dataIndex}`}
            value={selectedKeys[0]}
            onChange={(e) => {
              setSelectedKeys(e.target.value ? [e.target.value] : []);
              handleSearch(e, confirm, dataIndex);
            }}
            style={{ width: 188, marginBottom: 8, display: "block" }}
          />
        </div>
      ),
      filterIcon: (filtered) => (
        <SearchOutlined style={{ color: filtered ? "#1890ff" : undefined }} />
      ),
      onFilter: (value, record) =>
        record[dataIndex]
          ? record[dataIndex]
              .toString()
              .toLowerCase()
              .includes(value.toLowerCase())
          : "",
      onFilterDropdownOpenChange: (visible) => {
        if (visible) {
          setTimeout(() => searchInput.select(), 100);
        }
      },
    };
  };
  const handleSearch = (e, confirm, dataIndex) => {
    const value = e.target.value;
    debouncedSearch(value, dataIndex, confirm);
  };

  const columns = [
    {
      title: t("numZakaz"),
      dataIndex: "docNum",
      key: "docNum",
      // ...getColumnSearchProps("docEntry"),
    },

    {
      title: t("date"),
      dataIndex: "docDate",
      key: "docDate",
    },

    {
      title: t("from-whs"),
      dataIndex: "fromWarehouseName",
      key: "fromWarehouseName",
    },

    {
      title: t("toWhs"),
      dataIndex: "toWarehouseName",
      key: "toWarehouseName",
    },
  ];

  return (
    <div className="flex w-full">
      <Menubar />
      <div className="h-screen w-full overflow-y-auto">
        <Header
          title={"inventoryTransferRequests"}
          currentPage={currentPage + 1}
          handlePreviousPage={handlePreviousPage}
          handleNextPage={handleNextPage}
          hasMoreData={hasMore}
          onBtnClick={handleCreateProductClick}
          columns={columns}
          fdata={fdata}
          loading={loading}
          handleRowClick={handleRowClick}
          onStartDateChange={handleStartDate}
          onEndDateChange={handleEndDate}
          startDate={startDate}
          endDate={endDate}
          formattedDate={moment().format("YYYY-MM-DD")}
          // scrollX={1200}
        />
        <InventoryTransfersModal
          visible={isModalVisible}
          data={selectedRowData}
          onClose={closeViewModal}
          showCancelBtn={true}
          showShipBtn={true}
          isEditDriverAndLoaders={true}
          isEditGivingQuantity={true}
          showShippingLoaders={true}
          showShippingLoaderBtn={true}
          isShowLoaderPdfShipping={true}
          isInventoryRequestMenu={true}
        />
        <CreateInventoryTransferRequest
          visible={isCreateProductModalVisible}
          onClose={closeCreateProductModal}
        />
      </div>
    </div>
  );
};

export default InventoryTrasferRequest;
